import {createCustomNavigator} from '@dynamynd/core';
import {navigationService} from '@dynamynd/dynamynd';
import {screenProps} from './../core/screenProps';
import {appNavigator} from './app.navigator';

export const customNavigator = createCustomNavigator(appNavigator, navigationService, screenProps);
